import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { ErrorsService } from '../modules/shared/services/errors.service';
import { LogService } from '../modules/shared/services/log.service';

declare var SCWS: any;

@Injectable({
  providedIn: 'root'
})
export class ESignatureErrorHandler implements ErrorHandler {


  constructor(
    private injector: Injector,
    private errorsService: ErrorsService,
    private ngZone: NgZone,
    private LOG: LogService) {
  }

  handleError(error: any): void {
    const router = this.injector.get(Router);
    this.errorsService.error = error;
    if (this.errorsService.error instanceof SCWS.Error) {
      //TODO
      this.LOG.log('ERROR {0} : ', this.errorsService.error);
    } else {
      this.LOG.error(error);
      this.ngZone.run(() => {
        router.navigateByUrl('/erreur');
      });
    }

  }

}
